
const Constants = {
   SetPortfolioList: 'portfolio_setPortfolioList',
   SetCurPortfolio: 'portfolio_setCurPortfolio',
   SetSynthesisTemplates: 'portfolio_setSynthesis',
};

exports.Reducer = (state={},action) =>{
   switch(action.type){
      case Constants.SetPortfolioList:
         return {...state, portfolioList: action.portfolioList, isLoaded: true};
      case Constants.SetCurPortfolio:{
         return {...state, curPortfolio: action.portfolio}
      }
      case Constants.SetSynthesisTemplates:{
         return {...state, synthesisTemplates: action.synthesisTemplates}
      }
      default:
         return state;
   }
};

const FunctionList = {};

FunctionList.setPortfolioList = (portfolioList) => {
   return{
      type: Constants.SetPortfolioList,
      portfolioList
   }
};

FunctionList.setCurPortfolio = (portfolio) => {
   return{
      type: Constants.SetCurPortfolio,
      portfolio
   }
};

FunctionList.setSynthesisTemplates = (synthesisTemplates) => {
   return{
      type: Constants.SetSynthesisTemplates,
      synthesisTemplates
   }
};

exports.FunctionList = FunctionList;
